import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {

  idiomaActual:string;

  etiquetas = [
    { tag: '{{name}}', info: 'LEADER_GO.SECCION_PROGRAMACION.ETIQ.tag_name', tipo: 'SHEDULE2_0.EDITOR.MODALINFO.OPC' },
    { tag: '{{codeCoupon}}', info: 'LEADER_GO.SECCION_PROGRAMACION.ETIQ.tag_codeCoupon', tipo: 'SHEDULE2_0.EDITOR.MODALINFO.OPC' },
    { tag: '{{productoId}}', info: 'LEADER_GO.SECCION_PROGRAMACION.ETIQ.tag_productoId', tipo: 'SHEDULE2_0.EDITOR.MODALINFO.OPC' },
    { tag: '{{nameCourse}}', info: 'LEADER_GO.SECCION_PROGRAMACION.ETIQ.tag_nameCourse', tipo: 'SHEDULE2_0.EDITOR.MODALINFO.OPC' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalInfoComponent>,
    private translateSrv: TranslateService
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log(this.data);
  }

  salir() {
    this.dialogRef.close();
  }

}
